import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Switch } from './ui/switch';
import { getConsent, saveConsent, initConsent } from '../lib/consent';

export const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const [settings, setSettings] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    initConsent();
    if (!getConsent()) setShow(true);
    const open = () => { setAnalytics(!!getConsent()?.analytics); setSettings(true); };
    window.addEventListener('open-cookie-settings', open);
    return () => window.removeEventListener('open-cookie-settings', open);
  }, []);

  const choose = (value) => { saveConsent(value); setShow(false); setSettings(false); };
  const btn = 'flex-1 px-3 py-2.5 text-xs font-semibold tracking-wide transition-colors';

  return (
    <>
      {show && !settings && (
        <div role="dialog" aria-label="Cookie consent" className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-[70] bg-white border border-[#E5D8D0] shadow-xl p-5" data-testid="cookie-banner">
          <div className="flex items-center gap-2 mb-2"><Cookie className="w-4 h-4 text-[#DEA193]" /><p className="font-semibold text-sm">Cookies on Split Soul</p></div>
          <p className="text-xs text-[#555] leading-relaxed mb-4">
            We use essential cookies to run the shop (basket, login, checkout). With your permission we'd also like to use Google Analytics to understand how the site is used. <Link to="/privacy" className="underline">Privacy policy</Link>
          </p>
          <div className="flex gap-2">
            <button type="button" onClick={() => choose(true)} className={`${btn} bg-black text-white hover:bg-[#222]`} data-testid="cookie-accept-all">Accept all</button>
            <button type="button" onClick={() => choose(false)} className={`${btn} border border-black hover:bg-[#F7F7EB]`} data-testid="cookie-reject">Reject non-essential</button>
          </div>
          <button type="button" onClick={() => { setAnalytics(false); setSettings(true); }} className="mt-3 text-xs underline text-[#555]" data-testid="cookie-settings-btn">Settings</button>
        </div>
      )}
      <Dialog open={settings} onOpenChange={(o) => { setSettings(o); if (!o && !getConsent()) setShow(true); }}>
        <DialogContent className="bg-white max-w-md rounded-none" data-testid="cookie-settings-dialog">
          <DialogHeader><DialogTitle>Cookie settings</DialogTitle></DialogHeader>
          <div className="space-y-4 text-sm">
            <div className="flex items-start justify-between gap-4 border-b border-[#E5D8D0] pb-4">
              <div><p className="font-semibold">Essential</p><p className="text-xs text-[#737373]">Needed for your basket, account, checkout and security. Always on.</p></div>
              <Switch checked disabled aria-label="Essential cookies" data-testid="cookie-essential-switch" />
            </div>
            <div className="flex items-start justify-between gap-4">
              <div><p className="font-semibold">Analytics</p><p className="text-xs text-[#737373]">Google Analytics helps us see which pages and products are popular. Off unless you switch it on.</p></div>
              <Switch checked={analytics} onCheckedChange={setAnalytics} aria-label="Analytics cookies" data-testid="cookie-analytics-switch" />
            </div>
            <button type="button" onClick={() => choose(analytics)} className="w-full py-3 bg-black text-white text-xs font-semibold tracking-widest uppercase" data-testid="cookie-save-settings">Save choices</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
